/**
 * ``/workspace/projects`` index — Project Hub landing.
 *
 * Renders the grid of every non-archived project with search + "Nuovo" CTA.
 * The actual hub UI lives in ``features/projects/components/ProjectHub.tsx``
 * so the route stays a trivial file (consistent with workspace/templates,
 * workspace/automations).
 */

import { createFileRoute } from "@tanstack/react-router";

import { ProjectHub, projectsQueryOptions } from "@/features/projects";

export const Route = createFileRoute("/_authed/workspace/projects/")({
  // Warm the projects list on hover/focus (intent preload) so the hub paints
  // from cache. Fire-and-forget: a slow/failed prefetch must not block or
  // error the navigation — the component's own `useProjects` still renders
  // loading/error states.
  loader: ({ context: { queryClient } }) => {
    void queryClient.ensureQueryData(projectsQueryOptions());
  },
  component: ProjectHub,
});
